import React from 'react';
import config from 'react-global-configuration';

import { SearchAutocomplete as RSKSearchAutocomplete } from '@uncinc/react-searchkit';
import type { SearchAutocompleteProps as Type } from '@uncinc/react-searchkit/dist/components/Autocomplete';

import {
  SEARCHKIT_AUTOCOMPLETE_ATTRIBUTES,
  SEARCHKIT_AUTOCOMPLETE_FUZZINESS,
  SEARCHKIT_AUTOCOMPLETE_HITS,
  SEARCHKIT_AUTOSUGGEST_ATTRIBUTES,
  SEARCHKIT_AUTOSUGGEST_HITS,
  SEARCHKIT_HOST_URL,
  SEARCHKIT_INDEX_ALL_CONTENT,
  SEARCHKIT_RESULT_ATTRIBUTES,
} from '../../../config/constants';

import Inner, { type SearchAllContentAutocompleteInnerProps } from './Inner';

export interface SearchAllContentAutocompleteProps extends SearchAllContentAutocompleteInnerProps {
  autocompleteProps?: Omit<Type,
  | 'connection'
  | 'indexName'
  | 'resultAttributes'
  | 'autocompleteAttributes'
  | 'autocompleteResults'
  | 'autosuggestAttributes'
  | 'autosuggestResults'
  | 'reverseTypeOrder'
  | 'searchSettings'
  >;
}

const SearchAllContentAutocomplete: React.FC<SearchAllContentAutocompleteProps> = ({
  autocompleteProps,
  ...restProps
}) => (
  <RSKSearchAutocomplete
    {...autocompleteProps}
    connection={{ host: SEARCHKIT_HOST_URL }}
    indexName={SEARCHKIT_INDEX_ALL_CONTENT}
    resultAttributes={SEARCHKIT_RESULT_ATTRIBUTES}
    autocompleteAttributes={SEARCHKIT_AUTOCOMPLETE_ATTRIBUTES}
    autocompleteFuzziness={SEARCHKIT_AUTOCOMPLETE_FUZZINESS}
    autocompleteResults={SEARCHKIT_AUTOCOMPLETE_HITS}
    autosuggestAttributes={SEARCHKIT_AUTOSUGGEST_ATTRIBUTES}
    autosuggestResults={SEARCHKIT_AUTOSUGGEST_HITS}
    reverseTypeOrder
    searchSettings={{
      highlight_attributes: ['title', 'title_suggest'],
    }}
    queryFilters={[
      {
        // @ts-expect-error A 'must' query if not part of the QueryDslQueryContainer
        // typing, but the query is valid nonetheless. This should be fixed in
        // @elastic/elasticsearch/lib/api/types
        bool: {
          must: {
            term: {
              field_domain_access: {
                value: config.get('CURRENT_DOMAIN_DRUPAL_IDENTIFIER') as string,
              },
            },
          },
        },
      },
    ]}
  >
    <Inner {...restProps} />
  </RSKSearchAutocomplete>
);


export default SearchAllContentAutocomplete;
